import { render, staticRenderFns } from "./ResourceFileRow.vue?vue&type=template&id=19ce9720&"
import script from "./ResourceFileRow.vue?vue&type=script&lang=ts&"
export * from "./ResourceFileRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports